import { useState, useEffect } from "react";
import sanityClient from "../sanityClient";
import { postsQuery } from "../queries/postQuery";
import { StandardLayout } from "../layouts/StandardLayout";
import { PostListLayout } from "../layouts/PostListLayout";

export default function AllPosts() {
    const [postData, setPostData] = useState(null);

    useEffect(() => {
        sanityClient
            .fetch(postsQuery)
            .then((data) => setPostData(data))
            .catch(console.error);
    }, []);

    if (postData) {
        return <PostListLayout title={"All Posts"} posts={postData} />;
    } else {
        return <StandardLayout title={"All Posts"} content={"Loading..."} />;
    }
}
